'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPassThroughProps = exports.I18nCommonMixin = exports.commonPropTypes = undefined;

var _react = require('react');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonPropTypes = exports.commonPropTypes = {
  message: _react.PropTypes.string.isRequired,
  options: _react.PropTypes.object,
  useGap: _react.PropTypes.bool
};

var I18nCommonMixin = exports.I18nCommonMixin = {
  getDefaultProps: function getDefaultProps() {
    return {
      options: {},
      useGap: false
    };
  },
  _getValue: function _getValue() {
    var _props = this.props,
        useGap = _props.useGap,
        message = _props.message,
        options = _props.options;

    var value = _I18n2.default.text(message, options);
    if (useGap === true) {
      value = ' ' + value + ' ';
    }
    return value;
  }
};

var getPassThroughProps = exports.getPassThroughProps = function getPassThroughProps(allProps) {
  var result = {
    'data-locale-at-render': _I18n2.default.locale,
    'data-key': allProps.message
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(allProps)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var propKey = _step.value;

      if (['message', 'options', 'useGap'].indexOf(propKey) < 0) {
        result[propKey] = allProps[propKey];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
};